export enum SciPage {
  Order = 'order',
  PageLayout = 'pageLayout',
  PaymentLoading = 'paymentLoading',
  NotFound = 'notFound',
  Help = 'help',
}
